/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 17:46:56
 * @LastEditTime: 2019-08-17 16:55:13
 * @LastEditors: Do not edit
 */
import url from 'url';
import { Toast } from 'antd-mobile';
const crgt = window.crgt || {};

window._baseUrl = crgt.isProd ? "https://static.ccrgt.com" : "https://t-static.ccrgt.com";

// 当前环境
export function isProd() {
  return crgt.isProd;
}

export function debounce(func, wait, immediate) {
  // immediate默认为false
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    const last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    // 第一次调用该方法时，且immediate为true，则调用func函数
    const callNow = immediate && !timeout;
    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export function throttle(func, wait, options) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true;
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  let context, args, result;
  let timeout = null;
  let previous = 0;
  if (!options) options = {};
  const later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    const now = Date.now();
    if (!previous && options.leading === false) previous = now;
    // 计算剩余时间
    const remaining = wait - (now - previous);
    context = this;
    args = arguments;
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

// 去除左右空格
export function trim(s){
  return s.replace(/(^\s*)|(\s*$)/g, "");
}

// 大转盘
export function turntable(n, callback) {
  let m = 20,
      d = +n * m, //duration(持续次数)
      c = d, //change(变化量)
      t = 1, //time(初始记步次数)
      b = 1; //begin(初始位置)
  
  let num = 0;
  
  let T = (t, b, c, d) => {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  };
  
  function run(){

    if(typeof callback === "function"){
      let tempNum = Math.ceil(T(t, b, c, d)/m);

      if(num !== tempNum && tempNum <= Math.ceil(d/m)){
        num = tempNum;
        callback(num);
      }
    }
    
    if (t < d) {

      t++;

      setTimeout(function(){
        run();
      }, 10);
    }
  }

  run();
}

// 倒计时
export function tick(n, callback){

  let d = n * 1000, //持续时间
      c = d, //变化值
      t = 0, //当前时间
      b = 1, //当前值
      s = new Date().getTime();

  let T = (t, b, c, d) => (c * t / d + b);
      
  let timer = null;

  function run(){
    let t = new Date().getTime() - s;

    if(tick.isStop) {
      clearTimeout(timer);
      timer = null;
      return false;
    }

    if (d > t) {
      if (typeof callback === "function") {
        callback(Math.ceil(T(t, b, c, d) / 1000))
      };
      timer = setTimeout(function(){
        run();
      }, 1000);
    };
  }
  run();
}

// 获取url参数
export function getRequestData(){

  let params = {};

  let ur = window.location.href.split("?");
  let r1 = ur[1];
  let r = !!r1 ? r1.split("#")[0] : undefined;
  let d = [];
  
  if(ur.length >= 2) {
    r = "";
    for(let i=1; i<ur.length; i++) {
      r += `${ur[i]}&`;
    }
  }

  if(r !== undefined) {
    d = r.split("&");
  } else {
    return null;
  }

  if(d.length === 0) return null;

  for(let i=0; i<d.length; i++) {
    if(d[i] !== "") {
      let a = d[i].split("=");
      params[a[0]] = a[1].replace("\/", "").replace("#", "");
    }
  }
  
  return params;
}

// 去下载
export function goDownload(chid = null, crgtFrom = null) {
  let url = 'https://static.ccrgt.com/download/?openapp=true&page=netcar_index&actid=128'
  if (crgtFrom === 4) {
    url = 'https://static.ccrgt.com/download/?start_download=true&actid=128'
  }
  if (chid) url += '&chid=' + chid
  window.location.href = url
}

// 日期格式化
export function formatTime(time, pattern) {
  if (!time) return '';
  const date = new Date(time);
    const o = {
      "M+" : date.getMonth()+1, //月份
      "d+" : date.getDate(), //日
      "h+" : date.getHours()%12 === 0 ? 12 : date.getHours()%12, //小时
      "H+" : date.getHours(), //小时
      "m+" : date.getMinutes(), //分
      "s+" : date.getSeconds(), //秒
      "S" : date.getMilliseconds() //毫秒
    };
    const week = {
      "0" : "/u65e5",
      "1" : "/u4e00",
      "2" : "/u4e8c",
      "3" : "/u4e09",
      "4" : "/u56db",
      "5" : "/u4e94",
      "6" : "/u516d"
    };
    if(/(y+)/.test(pattern)){
      pattern=pattern.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
    if(/(E+)/.test(pattern)){
      pattern=pattern.replace(RegExp.$1, ((RegExp.$1.length>1) ? (RegExp.$1.length>2 ? "/u661f/u671f" : "/u5468") : "")+week[date.getDay()+""]);
    }
    for(let k in o){
      if(new RegExp("("+ k +")").test(pattern)){
        pattern = pattern.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
    }
    return pattern;
}

// 获取随机数区间
export function randomFrom(lowerValue, upperValue) {
  return Math.floor(Math.random() * (upperValue - lowerValue + 1) + lowerValue);
}

// 是否是APP
export function isCRGT() {
  return crgt.isCRGT;
}

// 如果是小程序进入
export function isMP() {
  return crgt.isQQMp || crgt.isWXMp;
}

// 判断是否在h5
export function isH5() {
  return !crgt.isCRGT && !crgt.isQQMp && !crgt.isWXMp;
}

// 获取 设备
export function trackFrom() {

  if(isH5()) {
    return "h5";
  }

  if(isMP()) {
    return "mp";
  }

  if(isCRGT()) {
    return "app";
  }
}

// 埋点PV
export function trackPV(EID, ACTID){

  window.CRGTA.Event.trackPV({
    Body: {
      EID,
      FROM: trackFrom(),
      ACTID,
    },
  }, true);
}

// 埋点Click
export function trackClick(EID, ACTID, others){
  let urlParams = getRequestData()|| {};
  let refer = urlParams.refer || "";

  window.CRGTA.Event.trackClick({
    Body: {
      EID,
      refer,
      FROM: trackFrom(),
      ACTID,
      ...others,
    },
  }, true);
}

// 直接分享
export function shareTo(type, wxShareInfoData) {

  let wxShareInfo = {...wxShareInfoData};

  wxShareInfo.style = type === 1 ? 1 : 0;
  wxShareInfo.imgUrl = type === 1 ? wxShareInfoData.imgUrlMP : wxShareInfoData.imgUrl;
  wxShareInfo.type = type;
  wxShareInfo.title = wxShareInfoData.desc;
  wxShareInfo.miniProgramType = isProd ? 0 : 2;
  wxShareInfo.path = url.format({
    pathname: '/pages/activity/index',
    query: {
      url: wxShareInfoData.link,
      requireUserInfo: 'true',
    },
  });

  let {desc, path, imgUrl, style, title} = wxShareInfo;

    window.crgt.share.shareTo({
      style,
      type,
      title,
      desc,
      path,
      imgUrl,
    }).then((res)=>{

    if(res.code === 0) {
      Toast.info("分享成功!");
    }
    if(res.code === 1) {
      Toast.info("分享失败!");
    }
    if(res.code === 2) {
      Toast.info("分享取消!");
    }
  });
}

// 跨段微信分享
export function wxShareAll(wxShareInfo, callback, self) {

  let shareType = {
    "sendAppMessage": 1,
    "shareTimeline": 2,
    "shareQQ": 3,
    "shareQZone": 4,
  }

  wxShareInfo.style = 1;
  wxShareInfo.type = 1;
  wxShareInfo.miniProgramType = isProd ? 0 : 2;
  wxShareInfo.path = url.format({
    pathname: '/pages/activity/index',
    query: {
      url: wxShareInfo.link,
      requireUserInfo: 'true',
    },
  });
  
  // 如果是app打开
  if(isCRGT()) {

    crgt.share.showShareMenu(wxShareInfo).then(res => {

      if(res.code === 0) {
        if(typeof callback === "function") {
          callback(self, res.data && res.data.type);
        }
        Toast.info("分享成功");
      }
    });
  } else if(isMP()) {
    
    crgt.util.loadScript('https://res.wx.qq.com/open/js/jweixin-1.4.0.js').then( () => {
      window.wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
  
          let {title, desc, path, imgUrlMP} = wxShareInfo;
  
          window.wx.miniProgram.postMessage({
            data: {
              title: desc,
              desc,
              path,
              imgUrl: imgUrlMP,
            }
          });
        }
      });
    });
    
  } else {

    wxShareInfo.success = function(d) {
      let typeName = d.errMsg.split(":")[0];
      let type = shareType[typeName];

      if(typeof callback === "function") {
        callback(self, type);
      }

      Toast.info("分享成功");
    }

    crgt.share.setShareInfo(wxShareInfo);
  }
}

// 获取token并且登录
export function getTokenAndLogin(needToken = true) {

  return new Promise((resolve, reject)=>{

    if(!needToken) {
      resolve("");
      return;
    }

    window.crgt.getToken().then((res)=>{
      if(res) {
        resolve(res);
      } else {
        window.crgt.router.openLogin().then((res)=>{
          if(res.accessToken) {
            resolve(res.accessToken);
          } else {
            resolve(false);
          }
        });
      }
    });
  });
}

// 获取token
export function getToken() {
  return new Promise((resolve, reject) => {
    window.crgt.getToken().then((res)=>{
      resolve(res || null);
    });
  });
}

// 订餐页面
export function toUserMeal(){
  let urlParams = getRequestData() || {};

  if (isCRGT()) {
    crgt.router.openProtocol({
      protocol: 'crgt',
      path: 'common/rn/FoodOrder',
      params: {
        "needlogin": true,
      }
    });
  } else if(isMP()) {

    // 打车 /pages/map/index
    // 订餐 /pages/ordering-meals/redirect/index
    crgt.router.openView({
      path: '/pages/ordering-meals/redirect/index',
      params: {}
    });

  } else {
    goDownload(urlParams.chid, urlParams.crgt_from);
  }
}

// 跳转神券页面
export function toUserCoupon(){
  let urlParams = getRequestData() || {};

  if (isCRGT()) {
    crgt.router.openUrl({
      url: `${window._baseUrl}/FE-H5-COUPON-GROUPON-V2/#/`,
      target: 0,
    });

  } else if(isMP()) {


    let urlParams = getRequestData();
    // let urlJumpParams = url.format({
    //     query: {
    //       ...urlParams,
          
    //     }
    //   });

    let urlJump = url.format({
      pathname: '/pages/activity/index',
      query: {
        url: `${window._baseUrl}/FE-H5-COUPON-GROUPON-V2/#/`,
        requireUserInfo: 'true',
      },
    });

    // console.log(`${window._baseUrl}/FE-H5-COUPON-GROUPON-V2/#/?${urlJump}`)
    // window.location.href = `${window._baseUrl}/FE-H5-COUPON-GROUPON-V2/#/${urlJumpParams}`;

    window.wx.miniProgram.navigateTo({
      url: urlJump
    });

    // window.wx.miniProgram.redirectTo({
    //   url: urlJump
    // });

    // window.crgt.router.openUrl({
    //   url: urlJump,
    // });

  } else {
    goDownload(urlParams.chid, urlParams.crgt_from);
  }
}
